import Keycloak from 'keycloak-js';

export const keycloakInitOps: Keycloak.KeycloakInitOptions = {
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  checkLoginIframe: false,
};

export class KeycloakInstanceWrapper {
  private static instance: Keycloak.KeycloakInstance | null;

  static getInstance(): Keycloak.KeycloakInstance {
    if (KeycloakInstanceWrapper.instance) {
      return KeycloakInstanceWrapper.instance;
    }

    const brand = localStorage.getItem('brand');
    const country = localStorage.getItem('country');

    if (!brand || !country) {
      throw Error('Wrong realm name because brand or country is not defined');
    }

    KeycloakInstanceWrapper.instance = Keycloak({
      url: window.env?.REACT_APP_KC_API,
      realm: `questionnairesurveyor-realm-${country}-${brand}`,
      clientId: 'questionnairesurveyor-ui',
    });
    return KeycloakInstanceWrapper.instance;
  }
}
